import { lazyComponent } from "@/client/lib/lazy-component";

// The AI SDK and the Markdown renderer come with the chat, and the panel around it with them, so
// it is fetched when asked for rather than with every screen.
export const foredayChat = lazyComponent(() =>
  import("@/client/components/foreday-panel").then((m) => m.ForedayPanelBody),
);
